import { Box, Grid } from '@mui/material';
import React, { useMemo } from 'react';
import strings from '../../Globalization/index';
import { useModelForm } from '../../contexts/ModelForm';
import FormGroupInputs from './FormGroupInputs';



const SectionFormGroups = () => {
	const {formGroups, formik, activeRecord} = useModelForm()
	const formGroupsArr = useMemo(
		() =>
			Array.isArray(formGroups)
				? formGroups.map(({ header, headerProps, containerProps, fields, ...rest }) => ({
						header: typeof header === 'function' ? header({ formik, activeRecord }) : strings[header] || header,
						headerProps: typeof headerProps === 'function' ? headerProps({ formik, activeRecord }) : headerProps,
						containerProps:
							typeof containerProps === 'function' ? containerProps({ formik, activeRecord }) : containerProps,
						fields: typeof fields === 'function' ? fields({ formik, activeRecord }) : fields,
						...rest
				  }))
				: [],
		[formGroups, formik, activeRecord]
	);
	return (
		<Grid container>
			{formGroupsArr.map(({ customizeFormGroup: FormGroupComponent, ...formGroup }, index) =>
				FormGroupComponent ? (
					<FormGroupComponent
						{...formGroup}
						formik={formik}
						activeRecord={activeRecord}
						key={`form-group-${index}`}
					>
						<FormGroupInputs formGroup={formGroup} />
					</FormGroupComponent>
				) : (
					<Grid size={12} {...formGroup?.slotProps?.wrapper} key={`form-group-${index}`}>
						{formGroup.header && (
							<Grid size={12} sx={{ display: 'flex' }}>
								<Box component="span" {...formGroup.headerProps} className={`${formGroup?.headerProps?.className || ''} section-formgroup-header`}>
									{strings[formGroup.header] || formGroup.header}
								</Box>
							</Grid>
						)}
						<Grid container size={'grow'} columnSpacing={1} {...formGroup.containerProps}>
							<FormGroupInputs formGroup={formGroup} />
						</Grid>
					</Grid>
				)
			)}
		</Grid>
	);
};

export default SectionFormGroups;
